import * as _ from 'lodash';
import {
  IInfiniteFetchOptions,
  IInfiniteFetchResults,
  IInfiniteScrollLoader
} from "~/interfaces/infiniteScrollInterfaces";

const ALWAYS_IGNORE_FOR_NORMALIZATION: Readonly<string[]> = Object.freeze([
  'forceNewQuery',
]);

export default class InfiniteScrollLoader implements IInfiniteScrollLoader {
  fetchPromise;
  lastRequestParameters;
  currentPage;

  constructor(fetchPromise) {
    this.fetchPromise = fetchPromise;
  };

  fetch(incomingRequestParameters, functionOptions: Partial<IInfiniteFetchOptions> = {queryKey: "query"}): Promise<IInfiniteFetchResults> {
    // message_notification_ids are used to keep track of loading message threads within infinite scroll
    // and should not effect logic for calculating `isNewQuery`
    let messageNotificationIds = null;
    if (incomingRequestParameters['message_notification_ids']) {
      messageNotificationIds = incomingRequestParameters['message_notification_ids'];
      delete incomingRequestParameters['message_notification_ids'];
    }
    const normalizedRequestParameters = InfiniteScrollLoader.normalizeRequestParameters(incomingRequestParameters);
    const isNewQuery = incomingRequestParameters.forceNewQuery || !_.isEqual(normalizedRequestParameters, this.lastRequestParameters);
    this.lastRequestParameters = normalizedRequestParameters;

    // If there were ids... Add them back to the params so the backend can calculate message threads
    if (messageNotificationIds) {
      incomingRequestParameters['message_notification_ids'] = messageNotificationIds;
    }

    if (isNewQuery) {
      this.currentPage = 1;
    } else {
      this.currentPage += 1;
    }

    const outgoingQuery = Object.assign({}, incomingRequestParameters.query, {page: this.currentPage});
    const baseOutGoingObject = functionOptions.queryKey ? {[functionOptions.queryKey]: outgoingQuery} : outgoingQuery;
    const outGoingRequestParameters = Object.assign({}, incomingRequestParameters, baseOutGoingObject);

    return new Promise((resolve, reject) => {
      this.fetchPromise(outGoingRequestParameters).then(({result, objects}) => {
        const isFullyLoaded = (objects.length === 0);

        resolve({result, objects, isFullyLoaded, isNewQuery});
      });
    });
  }

  static normalizeRequestParameters(requestParameters) {
    // if you don't do a deep clone, .columns[] and others get messed up
    const normalizedParameters = _.cloneDeep(requestParameters);

    if (
      normalizedParameters.query &&
      (normalizedParameters.query.q === '')
    ) {
      // parsing `query` from a URL w/ a blank 'q=' results in {q: ''}
      delete normalizedParameters.query.q;
    }

    requestParameters.query?.ignoreForNormalization?.forEach(param => { delete normalizedParameters.query[param] });
    delete normalizedParameters.query?.ignoreForNormalization;

    ALWAYS_IGNORE_FOR_NORMALIZATION.forEach(param => {
      delete normalizedParameters[param];
      normalizedParameters.query && delete normalizedParameters.query[param];
    });

    return normalizedParameters;
  }
}